

import axios from 'axios';
 const BASE_URL = 'http://localhost:8800';
//const BASE_URL = 'https://nerdayb.onrender.com';

export default axios.create({
    baseURL: process.env.REACT_APP_BASEURL
});

export const axiosPrivate = axios.create({
    baseURL: process.env.REACT_APP_BASEURL,
    headers: { 'Content-Type': 'application/json',
    "Access-Control-Allow-Origin": "true"
 },
    withCredentials: true
});
